import React from "react"
import {
  AdvantageBox,
  AdvantageInfoCover,
  AdvantagesInfoContainer,
  ImgCover,
  InfoDescription,
  InfoTitle,
  SubTitle,
  Title,
  DescCover,
} from "./styles"
import { StaticImage } from "gatsby-plugin-image"

const AcademyAdvantagesInfo = () => {
  return (
    <AdvantagesInfoContainer>
      <Title>Professional BIM & CAD Training</Title>
      <SubTitle>
        Over 20 years of experience in BIM Training &
        certification
      </SubTitle>
      <AdvantageInfoCover>
        <AdvantageBox>
          <ImgCover>
            <StaticImage
              src="../../../assets/images/double-check.png"
              alt=""
            />
          </ImgCover>
          <DescCover>
            <InfoTitle>Customised Training Plans</InfoTitle>
            <InfoDescription>
              Our modular courses are tailored to your
              project requirements
            </InfoDescription>
          </DescCover>
        </AdvantageBox>

        <AdvantageBox>
          <ImgCover>
            <StaticImage
              src="../../../assets/images/double-check.png"
              alt=""
            />
          </ImgCover>
          <DescCover>
            <InfoTitle>Experienced Trainers</InfoTitle>
            <InfoDescription>
              Over 20 years of exprience in BIM Training and
              Certifcation
            </InfoDescription>
          </DescCover>
        </AdvantageBox>

        <AdvantageBox>
          <ImgCover>
            <StaticImage
              src="../../../assets/images/double-check.png"
              alt=""
            />
          </ImgCover>
          <DescCover>
            <InfoTitle>Up-to-date Curriculum</InfoTitle>
            <InfoDescription>
              Our training standards allow us to qualify as
              an Autodesk Authorized Training Center and
              Bentley Training Partner
            </InfoDescription>
          </DescCover>
        </AdvantageBox>
      </AdvantageInfoCover>
    </AdvantagesInfoContainer>
  )
}

export default AcademyAdvantagesInfo
